"use client";

import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from "@/components/ui/hover-card";

import { Dialog, DialogTrigger, DialogContent } from "@/components/ui/dialog";

import { ArrowRight } from "@phosphor-icons/react";
import { useIsMobile } from "@/hooks/useIsMobile";

export default function FeatureItem({
  icon: Icon,
  title,
  description,
  details,
}) {
  const isMobile = useIsMobile();

  const trigger = (
    <div className='text-center transition lg:-translate-y-4 rounded-xl md:p-4 hover:bg-white hover:text-background group hover:translate-y-0'>
      <div className='flex flex-col justify-between gap-2 px-3 py-2 text-white transition-colors rounded-lg xl:gap-6 xl:px-4 xl:py-3 bg-white/15 group-hover:bg-background'>
        <span>
          <Icon weight='duotone' className='size-8 mb-1.5 mx-auto' />
          <span className='text-xl font-bold tracking-tight xl:leading-tight xl:text-2xl'>
            {title}
          </span>
        </span>
      </div>
      <p className='block mt-3 text-sm font-normal leading-normal'>
        {description}
      </p>
    </div>
  );

  const content = (
    <div className='space-y-2 text-xs font-normal leading-normal text-background/80'>
      {details}
    </div>
  );

  if (isMobile) {
    return (
      <Dialog>
        <DialogTrigger asChild>{trigger}</DialogTrigger>
        <DialogContent className='max-w-sm p-4 mx-auto bg-white rounded-xl text-background'>
          {content}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <HoverCard openDelay={50} closeDelay={50}>
      <HoverCardTrigger asChild>{trigger}</HoverCardTrigger>
      <HoverCardContent
        side='right'
        className='w-[420px] p-4 bg-white border-0 rounded-lg text-background'
      >
        {content}
      </HoverCardContent>
    </HoverCard>
  );
}
